import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { DashboardService } from '../../services/dashboard.service';

@Component({
  selector: 'app-testimonials',
  templateUrl: './testimonials.component.html',
  styleUrls: ['./testimonials.component.scss']
})
export class TestimonialsComponent implements OnInit {

  isLoading = true;

  loggedInUserDetails;

  getPartnerDetailsPostData = {
    section: '103'
  };

  saveStatus;

  myForm: FormGroup;

  submitted = false;
  formId = 1;
  existingData;

  removeParamForm;
  removeParamIndex;

  constructor(private fb: FormBuilder, private dashboardService: DashboardService) { }

  ngOnInit() {
    this.myForm = this.fb.group({
      testimonials: new FormArray([])
    });

    this.getInitialForms();
  }

  // getter  - (accessed as this.testimonialsForm in this file)
  get testimonialsForm() { return this.myForm.get('testimonials') as FormArray; }

  getInitialForms() {
    this.isLoading = true;

    this.dashboardService.getPartnerData(this.getPartnerDetailsPostData).subscribe(response => {
      this.isLoading = false;

      if (response.data.length >= 1) {
        this.existingData = response.data;
        this.setTestimonials();
      }
      else {
        this.testimonialsForm.push(
          this.fb.group({
            name: ['', Validators.required],
            designation: ['', Validators.required],
            testimonial_text: ['', Validators.required]
          })
        );
      }
    });
  }


  setTestimonials() {
    this.existingData.forEach(x => {
      this.testimonialsForm.push(this.fb.group({
        id: [x.id],
        name: [x.name, Validators.required],
        designation: [x.designation, Validators.required],
        testimonial_text: [x.testimonial_text, Validators.required]
      }));
    });
  }

  // add form
  addNewTestimonialForm() {
    this.testimonialsForm.push(
      this.fb.group({
        name: ['', Validators.required],
        designation: ['', Validators.required],
        testimonial_text: ['', Validators.required]
      })
    );
    this.submitted = false;
  }

  // remove form step-1 (Set remove params)
  setRemoveFromParameters(form, index) {
    this.removeParamForm = form;
    this.removeParamIndex = index;
  }

  // remove form step-2 (Remove)
  removeTestimonialForm() {
    if (this.removeParamForm.hasOwnProperty('id')) {
      let postData = {
        testimonial_id: this.removeParamForm.id
      }
      this.dashboardService.removeTestimonial(postData).subscribe(response => {
        this.testimonialsForm.removeAt(this.removeParamIndex);
      });
    }
    else {
      this.testimonialsForm.removeAt(this.removeParamIndex);
    }
    this.submitted = false;
  }


  nestedFormSubmit() {
    if (this.testimonialsForm.length == 0) {
      return;
    }

    this.submitted = true;

    if (this.myForm.invalid) {
      return;
    }

    this.dashboardService.setTestimonialsDetails(this.myForm.value).subscribe(response => {
      this.myForm.reset();
      this.testimonialsForm.clear();
      this.getInitialForms();
    });
  }
}
